window.VSF_SHROUD_CSV=`
gun_model,optic_brand,optic_model,shroud_size,note
GLOCK 9/40 DS,Trijicon,RMR HD,Small,,
GLOCK 9/40 DS,Trijicon,SRO,Small,,
GLOCK 9/40 DS,Trijicon,RMR  ,Small,,
GLOCK 9/40 DS,Trijicon,RCR,Large,,
GLOCK 9/40 DS,Aimpoint,Acro P-2,Large,,
GLOCK 9/40 DS,Aimpoint,COA,Large,,
GLOCK 9/40 DS,Leupold,DeltaPoint Pro,Small,,
GLOCK 9/40 DS,Holosun,507C X2,Small,,
GLOCK 9/40 DS,Holosun,508T X2,Small,,
GLOCK 9/40 DS,Holosun,507 COMP,Small,,
GLOCK 9/40 DS,Holosun,509T X2,Large,,
GLOCK 9/40 DS,Holosun,509 ACSS Vulcan,Large,,
GLOCK 9/40 DS,Steiner,MPS,Large,,
SIG P320,Sig Sauer,Romeo M17,Small,,
SIG P320,Sig Sauer,Romeo3 Max,Small,,
SIG P320,Sig Sauer,Romeo 1 Pro,Small,,
SIG P320,Sig Sauer,Romeo 2,Large,,
SIG P320,Trijicon,RMR HD,Small,,
SIG P320,Trijicon,SRO,Small,,
SIG P320,Trijicon,RMR  ,Small,,
SIG P320,Aimpoint,Acro P-2,Large,,
SIG P320,Holosun,507C X2,Small,,
SIG P320,Holosun,508T X2,Small,,
SIG P320,Holosun,507 COMP,Small,,
SIG P320,Leupold,DeltaPoint Pro,Small,,
S&W M&P 2.0,Trijicon,RMR,Small,,
S&W M&P 2.0,Trijicon,RMR HD,Small,,
S&W M&P 2.0,Trijicon,RCR,Large,,
S&W M&P 2.0,Trijicon,SRO,Small,,
S&W M&P 2.0,Aimpoint,Acro P-1,Large,,
S&W M&P 2.0,Aimpoint,Acro P-2,Large,,
S&W M&P 2.0,Steiner,MPS,Large,,
S&W M&P 2.0,Leupold,Delta Point Pro,Small,,
S&W M&P 2.0,Holosun,507C X2,Small,,
S&W M&P 2.0,Holosun,508T X2,Small,,
S&W M&P 2.0,Holosun,507 Comp,Small,,
S&W M&P 2.0,Vortex,Defender XL,Large,,
WALTHER PDP,Trijicon, RMR,Small,,
WALTHER PDP,Trijicon, SRO,Small,,
WALTHER PDP,Trijicon, RMR HD,Small,,
WALTHER PDP,Trijicon, RCR,Large,,
WALTHER PDP,Holosun,407C X2,Small,,
WALTHER PDP,Holosun,507C X2,Small,,
WALTHER PDP,Holosun,508T X2,Small,
WALTHER PDP,Holosun,507 COMP,Small,,
WALTHER PDP,Holosun,509T,Large,,
WALTHER PDP,Holosun,SCS PDP,Small,,
WALTHER PDP,Aimpoint,Acro P2,Large,,
WALTHER PDP,Steiner,MPS,Large,,
WALTHER PDP,Vortex,Defender XL,Large,,
WALTHER PDP,Leupold,DeltaPoint Pro,Small,,
FN 509,Trijicon, RMR,Small,,
FN 509,Trijicon, SRO,Small,,
FN 509,Trijicon, RMR HD,Small,,
FN 509,Trijicon, RCR,Large,,
FN 509,Holosun,407C X2,Small,,
FN 509,Holosun,507C X2,Small,,
FN 509,Holosun,508T X2,Small,
FN 509,Holosun,507 COMP,Small,,
FN 509,Holosun,509T,Large,,
FN 509,Aimpoint,Acro P2,Large,,
FN 509,Steiner,MPS,Large,,
FN 509,Vortex,Defender XL,Large,,
FN 509,Leupold,DeltaPoint Pro,Small,,
`;
//# sourceMappingURL=/s/files/1/2471/4446/t/261/assets/vsf-data.js.map?v=1771966446
